import type { CategoryContent } from './row.js';

export const ROMANIAN_HISTORY: CategoryContent = {
  bscba: [
    [
      'Wallachia and Moldavia were medieval principalities whose territories lay primarily in what geographical region?',
      [
        'South of the Carpathians, in modern Romania',
        'The Balkans east of Serbia, west of the Black Sea',
        'The eastern Danube delta and surrounding plains',
        'Modern-day Moldova, north of Romania',
      ],
      0,
      'Wallachia occupied much of southern Romania; Moldavia lay to the northeast. Both were south and east of the Carpathians.',
    ],
    [
      'For most of the medieval and early modern period, Wallachia and Moldavia paid tribute to which empire?',
      [
        'The Ottoman Empire',
        'The Austro-Hungarian Empire',
        'The Russian Empire',
        'The Byzantine Empire',
      ],
      0,
      'Both principalities were Ottoman vassals from the 15th–19th centuries, paying annual tribute while retaining internal autonomy.',
    ],
    [
      'In 1859, Wallachia and Moldavia were unified into a single state under which leader?',
      [
        'Alexander John Cuza',
        'Carol I of Hohenzollern',
        'Michael the Brave',
        'Stephen the Great',
      ],
      0,
      'Cuza engineered the union of the two principalities, establishing the basis for modern Romania. Carol I became the first elected prince.',
    ],
    [
      'Romanian independence from the Ottoman Empire was formally recognized in which year?',
      [
        '1877',
        '1859',
        '1878',
        '1869',
      ],
      0,
      'Romania declared independence in 1877 during the Russo-Turkish War; the Treaty of Berlin in 1878 confirmed international recognition.',
    ],
    [
      'After World War I, Romania gained significant territory, creating "Greater Romania." Which major region was acquired?',
      [
        'Transylvania',
        'Crimea',
        'Galicia',
        'Bulgaria',
      ],
      0,
      'Transylvania (held by Austria-Hungary) joined Romania in 1918. Bukovina and Bessarabia were also acquired, doubling Romania\'s size.',
    ],
    [
      'Romania sided with which alliance during World War I?',
      [
        'The Entente Powers (Allies)',
        'The Central Powers (Germany, Austria-Hungary)',
        'Remained neutral throughout the war',
        'Joined late with the Ottoman Empire',
      ],
      0,
      'Romania entered WWI in 1916 alongside the Allies, hoping to gain Transylvania and other territories from Austria-Hungary.',
    ],
    [
      'During World War II, Romania initially allied with which nation?',
      [
        'Nazi Germany',
        'The Soviet Union',
        'The United Kingdom',
        'The United States',
      ],
      0,
      'Romania, under General Antonescu, joined the Axis powers in 1941, though it switched sides in 1944 as Soviet forces advanced.',
    ],
    [
      'The Romanian Communist takeover occurred in approximately which year?',
      [
        '1947',
        '1944',
        '1945',
        '1948',
      ],
      0,
      'The People\'s Republic of Romania was proclaimed in December 1947, consolidating Soviet-backed Communist control.',
    ],
    [
      'Nicolae Ceaușescu served as Romania\'s Communist leader for roughly how many years?',
      [
        '24 years (1965–1989)',
        '15 years (1970–1985)',
        '30 years (1955–1985)',
        '10 years (1975–1985)',
      ],
      0,
      'Ceaușescu led Romania from 1965 until his execution in December 1989, making him one of the longest-serving Communist leaders.',
    ],
    [
      'The fall of Communism in Romania was marked by a revolution in which year?',
      [
        '1989',
        '1988',
        '1990',
        '1991',
      ],
      0,
      'The Romanian Revolution occurred in December 1989, culminating in Ceaușescu\'s execution on December 25.',
    ],
    [
      'Transylvania, a region with a large ethnic Hungarian population, was part of which empire before joining Romania in 1918?',
      [
        'The Austro-Hungarian Empire',
        'The Ottoman Empire',
        'The Russian Empire',
        'Independent kingdoms and principalities',
      ],
      0,
        'Austria-Hungary held Transylvania until 1918. It became part of Greater Romania following WWI.',
    ],
    [
      'Stephen the Great was a famous medieval ruler of which principality?',
      [
        'Moldavia',
        'Wallachia',
        'Transylvania',
        'Dobruja',
      ],
      0,
      'Stephen (ruled 1457–1504) was Moldavia\'s greatest king, resisting Ottoman expansion and establishing cultural achievements.',
    ],
    [
      'Vlad III, known as "Vlad the Impaler," ruled which principality in the 15th century?',
      [
        'Wallachia',
        'Moldavia',
        'Transylvania',
        'Serbia',
      ],
      0,
      'Vlad III (c. 1431–1476) ruled Wallachia; his reputation for brutal punishment became legendary and partly inspired Dracula mythology.',
    ],
    [
      'Michael the Brave briefly unified all three Romanian territories (Wallachia, Moldavia, and Transylvania) in which period?',
      [
        '1594–1595',
        '1475–1476',
        '1520–1525',
        '1600–1605',
      ],
      0,
      'Michael the Brave (Mihai Viteazul) achieved a temporary union of the three regions in 1594–1595, a significant early milestone.',
    ],
    [
      'After the Ottoman Empire declined, which European power exerted the strongest political influence over Romania by the 19th century?',
      [
        'Russia',
        'Austria-Hungary',
        'France',
        'Prussia',
      ],
      0,
      'Russia\'s proximity and military strength made it the dominant external influence, though Austria-Hungary was also significant.',
    ],
  ],
  msc: [
    [
      'The Phanariotes were a class of rulers imposed on Wallachia and Moldavia for over a century. From which group were they drawn?',
      [
        'Greek officials and merchants appointed by the Ottoman sultans',
        'Local boyar aristocrats promoted by the Ottoman governors',
        'Romanian merchants who collaborated with Ottoman authorities',
        'European diplomats sent by rival empires to administer Ottoman territory',
      ],
      0,
      'Phanariotes were Greek-speaking Ottoman officials named after the Phanar district in Constantinople, ruling Wallachia and Moldavia (1711–1821).',
    ],
    [
      'The Organic Regulations of 1831–1834 established constitutional frameworks in Wallachia and Moldavia. Under which external power were they introduced?',
      [
        'The Russian Empire',
        'The Ottoman sultans directly',
        'Austria-Hungary\'s diplomatic pressure',
        'Britain and France\'s colonial administration',
      ],
      0,
      'Russia imposed the Organic Regulations as Ottoman suzerain, creating elected assemblies and modern administrative structures.',
    ],
    [
      'In the 1877–1878 Russo-Turkish War, Romania gained independence but ceded which territory to Russia?',
      [
        'Southern Bessarabia',
        'Transylvania entirely',
        'Wallachia\'s entire western border',
        'The Danube Delta',
      ],
      0,
      'Romania was forced to surrender southern Bessarabia to Russia as the price for Russian military support and Ottoman recognition of independence.',
    ],
    [
      'Ion C. Brătianu was a dominant political figure in late-19th and early-20th century Romania. Which party did he lead?',
      [
        'The National Liberal Party',
        'The Conservative Party',
        'The National Peasant Party',
        'The Social Democratic Party',
      ],
      0,
      'Brătianu was the National Liberal Party\'s leading figure, championing industrialization, land reform, and territorial expansion.',
    ],
    [
      'The interwar period (1918–1940) saw Romania attempt land reform. Which social group was the primary target of expropriation?',
      [
        'The old nobility\'s large estates',
        'Urban merchants and factory owners',
        'Orthodox Church properties',
        'Jewish-owned businesses in towns',
      ],
      0,
      'Land reform expropriated much of the nobility\'s vast estates and redistributed them to peasants, though implementation was slow.',
    ],
    [
      'King Carol II controversially declared himself dictator of Romania in what year?',
      [
        '1938',
        '1933',
        '1936',
        '1935',
      ],
      0,
      'Carol II established personal rule in 1938, marginalizing parliament and political parties as European authoritarianism rose.',
    ],
    [
      'General Ion Antonescu took power in Romania in 1940 and led it during World War II under which title?',
      [
        'Conducător',
        'Regent for the absent King Michael',
        'Prime Minister under royal authority',
        'Temporary military administrator',
      ],
      0,
      'Antonescu held the title "Conducător" and ruled as a military dictator, aligning Romania with Nazi Germany.',
    ],
    [
      'The Iron Guard (Legion of the Archangel Michael) was a fascist movement in Romania. Its leader was which figure?',
      [
        'Corneliu Codreanu',
        'Ion Antonescu',
        'Carol I',
        'Nicolae Ceaușescu',
      ],
      0,
      'Codreanu founded and led the Iron Guard (1927–1938) until his arrest and assassination in Communist-style purges.',
    ],
    [
      'Romania switched sides from the Axis to the Allies in August 1944 primarily due to which military development?',
      [
        'The rapid Soviet advance',
        'German military collapse in the west',
        'British naval pressure in the Black Sea',
        'American air superiority',
      ],
      0,
      'Soviet forces crossed Romania\'s border, prompting King Michael\'s coup against Antonescu and immediate declaration of war on Germany.',
    ],
    [
      'Romania\'s territories east of the Prut River (southern Bessarabia) were annexed into the Soviet Union in which year?',
      [
        '1940',
        '1918',
        '1945',
        '1950',
      ],
      0,
      'Soviet forces took Bessarabia in 1940; the territory remained Soviet (later Moldavian SSR) after WWII, a source of Romanian grievance.',
    ],
    [
      'Nicolae Ceaușescu promoted a doctrine of independence from Soviet control while remaining nominally Communist. What was this policy called?',
      [
        '"National Communism"',
        '"Balkan Liberation Movement"',
        '"Danube Federation"',
        '"Socialist patriotism"',
      ],
      0,
      'Ceaușescu pursued nationalist communism, defying Soviet orthodoxy on issues like the 1968 Czechoslovak invasion and foreign policy.',
    ],
    [
      'Ceaușescu\'s "Systematization" program of the 1970s–1980s primarily aimed at which transformation?',
      [
        'Rural depopulation and urban resettlement',
        'Industrial expansion and worker relocation',
        'Communist Party membership growth',
        'Reforestation and environmental restoration',
      ],
      0,
      'Systematization demolished rural villages and relocated peasants to urban agro-industrial complexes, destroying traditional communities.',
    ],
    [
      'Ceaușescu\'s "December Thesis" of 1989 was his response to unrest in Timișoara. What did it explicitly call for?',
      [
        'Suppression of "hooligans"',
        'Democratic reform and pluralism',
        'Soviet military intervention',
        'Economic privatization',
      ],
      0,
      'The December Thesis blamed foreign agents for uprising and demanded harsh suppression, foreshadowing the regime\'s final collapse.',
    ],
    [
      'Nicolae Ceaușescu and his wife Elena were executed on December 25, 1989. Who carried out the execution?',
      [
        'A military firing squad',
        'The Soviet Red Army',
        'Popular lynching by Bucharest crowds',
        'The Securitate secret police',
      ],
      0,
      'A military court sentenced both to death for genocide; a firing squad executed them the same day, ending their 24-year rule.',
    ],
    [
      'The 1989 Romanian Revolution began in which city, with unrest spreading to Bucharest?',
      [
        'Timișoara',
        'Iași',
        'Cluj',
        'Constanța',
      ],
      0,
      'Timișoara protests in December 1989 sparked the broader revolution that toppled Ceaușescu\'s regime within days.',
    ],
  ],
  phd: [
    [
      'The boyar class in medieval Wallachia and Moldavia occupied a social position between the princely court and peasantry. Which economic power base underpinned their influence?',
      [
        'Vast agricultural estates and local trade monopolies',
        'Ownership of textile workshops and urban merchant guilds',
        'Military command of urban garrison fortresses',
        'Ecclesiastical authority over monasteries and Orthodox churches',
      ],
      0,
      'Wallachchian and Moldavian boyars were hereditary landowners whose wealth derived from latifundia (large estates) and local trade privileges.',
    ],
    [
      'The 1831–1834 Organic Regulations established electoral assemblies in Wallachia and Moldavia. Which class was explicitly excluded from voting rights?',
      [
        'Peasants, Jews, and the urban poor',
        'Only women and children',
        'Foreigners and Orthodox priests',
        'Military officers and civil servants',
      ],
      0,
      'Voting was restricted to boyars, wealthy merchants, and some clergy—a narrow franchise excluding the rural and urban masses.',
    ],
    [
      'Cuza\'s 1864 land reform in the new unified state (Romania) affected what proportion of arable land?',
      [
        'About 25%, from Church lands',
        '50% of all private holdings',
        'Over 75% of the Danube floodplain',
        'Nearly 100% of forest reserves',
      ],
      0,
      'The 1864 reform redistributed Church and monastic lands (about a quarter of arable land) to peasants, but did not touch noble estates.',
    ],
    [
      'The Treaty of Berlin (1878) required Romania to grant civic rights to all residents regardless of religious faith. Which minority\'s status became a contentious political issue?',
      [
        'Jews',
        'Muslims in the border regions',
        'Catholics in Transylvania',
        'Evangelical Germans in Banat',
      ],
      0,
      'Romanian Jewish emancipation (1878) was formally mandated but resisted domestically; antisemitic restrictions persisted until WWII.',
    ],
    [
      'Romania\'s industrialization under Carol I (1881–1914) was heavily concentrated in which sector?',
      [
        'Oil extraction and refining',
        'Textile manufacturing in Wallachia',
        'Coal mining in Transylvania',
        'Grain milling and agricultural processing',
      ],
      0,
      'Romanian oil production became Europe\'s second-largest by 1900; foreign (especially British and Dutch) capital dominated the industry.',
    ],
    [
      'The National Peasant Party, founded 1926, represented a distinctive ideology combining which elements?',
      [
        'Agrarian populism and Orthodox nationalism',
        'Marxist class theory with peasant cooperative structures',
        'Liberal capitalism with free-trade universalism',
        'Syndicalist labor organization and urban socialism',
      ],
      0,
      'The National Peasant Party idealized the peasant as Romania\'s moral core, opposed industrialization, and rejected both liberalism and communism.',
    ],
    [
      'The Codreanu-led Legion of the Archangel Michael blended fascism with which religious and cultural element specific to Romania?',
      [
        'Orthodox mysticism of sacrifice',
        'Islamic Sufi traditions',
        'Protestant evangelical theology',
        'Pre-Christian pagan revival',
      ],
      0,
      'The Legion\'s ideology merged fascist ultranationalism with Orthodox mysticism; Codreanu\'s execution created a cult of martyrdom.',
    ],
    [
      'During the Phanariote period (1711–1821), Moldavian and Wallachian principalities served what administrative function within the Ottoman system?',
      [
        'Buffer states providing tribute and military levies',
        'Fully integrated provinces under direct Ottoman military rule',
        'Autonomous city-states with complete self-governance',
        'Fiefs granted to Ottoman military elite (Timars)',
      ],
      0,
      'The Ottoman system delegated rule to Phanariote governors, reserving direct control for strategic moments, maximizing profit while minimizing cost.',
    ],
    [
      'The 1944 King Michael coup resulted in which immediate geopolitical consequence?',
      [
        'Romania switched sides, but Soviet forces occupied it anyway',
        'Germany withdrew voluntarily; Romania maintained independence',
        'A Soviet satellite state was formally established with elections',
        'NATO forces reached Romania before Soviet occupation',
      ],
      0,
      'Michael\'s coup was symbolically significant but strategically hollow: Soviet forces were already advancing and occupation followed immediately.',
    ],
    [
      'Romanian Communists, numbering fewer than 1,000 in 1944, consolidated power through which mechanism?',
      [
        'Soviet occupation and a puppet government',
        'Popular election and mass recruitment',
        'Civil war and armed revolutionary struggle',
        'Negotiated coalition government with non-Communist parties',
      ],
      0,
      'The Romanian Communist Party lacked popular support; Soviet bayonets installed them. Party membership grew through coercion and incentives.',
    ],
    [
      'Ceaușescu\'s 1968 response to the Czechoslovak invasion was unique among Warsaw Pact nations. What did he do?',
      [
        'Publicly condemned the Soviet intervention as illegal',
        'Deployed troops alongside Soviet forces to suppress Czech resistance',
        'Remained entirely neutral and silent',
        'Secretly negotiated Romanian neutrality in exchange for Soviet tolerance',
      ],
      0,
      'Ceaușescu\'s August 1968 speech opposing the invasion boosted his legitimacy domestically and internationally, widening his autonomy from Moscow.',
    ],
    [
      'The Securitate, Romania\'s secret police, expanded most dramatically under which leader\'s tenure?',
      [
        'Nicolae Ceaușescu',
        'General Antonescu during WWII',
        'King Carol II in the 1930s',
        'Ion Dej in the 1950s',
      ],
      0,
      'Under Ceaușescu, the Securitate became one of Eastern Europe\'s most feared secret services, operating an extensive informant network.',
    ],
    [
      'Ceaușescu\'s doctrine of "socialist self-management" in factories was influenced by which country\'s Titoist model?',
      [
        'Yugoslav worker councils',
        'The Soviet kolkhoz system',
        'Chinese communes',
        'North Korea\'s juche system',
      ],
      0,
      'Ceaușescu partially adopted Yugoslavia\'s worker self-management model as an alternative to Soviet-style central planning.',
    ],
    [
      'The Timișoara uprising of December 1989 began as a protest against which immediate trigger?',
      [
        'Deportation of pastor László Tőkés',
        'Food rationing and bread shortages',
        'Soviet military intervention',
        'A factory wage cut',
      ],
      0,
      'Tőkés, an ethnic Hungarian pastor, faced deportation; his defense rallied Timișoara, uniting ethnic Romanians and Hungarians against the regime.',
    ],
    [
      'Post-1989 Romanian lustration and transitional justice processes differed from Central European neighbors in what key way?',
      [
        'Romania pursued minimal decommunization',
        'Romania conducted the most thorough Securitate trials in the region',
        'Romanian courts immediately prosecuted all Communist leaders',
        'Romania disbanded its military entirely and rebuilt from scratch',
      ],
      0,
      'Unlike Poland or Czechoslovakia, post-Communist Romania did not systematically purge the bureaucracy; continuity often trumped reckoning.',
    ],
  ],
  professor: [
    [
      'The 14th-century founding of Wallachia and Moldavia as discrete political entities resulted from which broader geopolitical fragmentation?',
      [
        'The collapse of Hungarian and Mongol overlordship',
        'Ottoman conquest and deliberate subdivision of conquered territories',
        'Papal authority fragmenting the region into ecclesiastical jurisdictions',
        'Byzantine imperial provinces being subdivided by succession disputes',
      ],
      0,
      'Both principalities emerged as independent polities in the vacuum left by the decline of Hungarian overlordship and Mongol suzerainty over the steppes.',
    ],
    [
      'Boyar rebellions and princely instability in Moldavia (15th–16th centuries) were fundamentally driven by which structural tension?',
      [
        'Boyar-prince competition over trade and tax revenue',
        'Religious schism between Catholicism and Orthodoxy',
        'Disputes over purely ceremonial prerogatives at court',
        'Labor shortage in salt mines and agricultural production',
      ],
      0,
      'Moldavian instability reflected zero-sum conflicts between princely revenue needs and boyar wealth concentration; Ottoman tribute compressed both.',
    ],
    [
      'The Russian-Turkish Convention of 1774 (Treaty of Küçük Kaynarca) granted which privilege to Russia regarding Wallachia and Moldavia?',
      [
        'A vague "protection" right over Ottoman Christians',
        'Outright territorial annexation of both principalities',
        'Control of Ottoman foreign policy toward Romania',
        'Exclusive trade monopoly in the Danube delta',
      ],
      0,
      'Küçük Kaynarca\'s Article 14 gave Russia shadowy "protector" status; Russia weaponized this ambiguity to justify intervention for a century.',
    ],
    [
      'Cuza\'s 1864 land reform deliberately exempted large boyar estates while redistributing Church lands. What fiscal rationale justified this compromise?',
      [
        'Church land was politically safer to seize than boyar land',
        'Boyar-owned land was economically unproductive and not worth taxing',
        'International treaties forbade confiscation of private property',
        'The Church volunteered its lands as patriotic contribution',
      ],
      0,
      'Cuza faced conservative resistance; confiscating boyar estates risked civil strife. Church expropriation was politically feasible without threatening the elite.',
    ],
    [
      'Romania\'s petroleum industry, dominated by foreign capital into the 1930s, created which structural economic dependency?',
      [
        'Heavy reliance on foreign-owned export revenue',
        'An oversupply of skilled workers forcing wage deflation',
        'Technological autarky and isolation from European markets',
        'Excessive state control stifling private entrepreneurship',
      ],
      0,
      'British, Dutch, and German oil firms extracted Romanian crude; profits flowed abroad, limiting capital available for broader Romanian industrialization.',
    ],
    [
      'The 1923 Romanian Constitution established universal male suffrage but retained which mechanism limiting democratic accountability?',
      [
        'Royal decree power and parliament dissolution',
        'A bicameral legislature with equal veto power on all measures',
        'Military oversight of all legislative sessions',
        'Ecclesiastical veto power over secular law',
      ],
      0,
      'The 1923 Constitution was liberal in form but granted the Crown sweeping executive prerogatives, permitting royal dictatorship (realized 1938).',
    ],
    [
      'The Legion of the Archangel Michael\'s ideology synthesized fascism with which theological concept endemic to Eastern Orthodoxy?',
      [
        'Redemptive suffering and martyrdom',
        'Papal infallibility claims',
        'Calvinist predestination',
        'Sufi mystical ecstasy',
      ],
      0,
      'The Legion\'s ethos blended fascist ultranationalism with Orthodox mysticism of sacrifice; Codreanu\'s assassination transformed him into a quasi-saint.',
    ],
    [
      'The Molotov-Ribbentrop Secret Protocols of August 1939 assigned Romania to which power\'s sphere of influence?',
      [
        'Officially undefined, but implicitly Soviet',
        'Germany\'s exclusive sphere',
        'Italy\'s Mediterranean domain',
        'Remained under League of Nations neutrality provisions',
      ],
      0,
      'The Protocols contained secret clauses granting Soviet hegemony over Bessarabia; Germany honored these, abandoning any claim to the region.',
    ],
    [
      'Romania\'s territorial losses (Bessarabia, northern Bukovina, southern Dobruja) between 1940–1945 stemmed from which geopolitical mechanisms?',
      [
        'Soviet advance and German indifference to Romania',
        'Purely voluntary Romanian cessions in negotiated treaties',
        'Ottoman claims reasserted after German occupation',
        'League of Nations punitive redistribution',
      ],
      0,
      'Soviet acquisition of Bessarabia (1940) and northern Bukovina was unilateral; Bulgaria\'s southern Dobruja gain (1940) was negotiated; Nazis sanctioned both.',
    ],
    [
      'The 1948–1952 period saw Romania\'s Stalinist leadership (Gheorghiu-Dej) pursue massive industrialization via which mechanism?',
      [
        'Forced collectivization',
        'Voluntary cooperative reorganization of farming',
        'Massive Western loans and technology transfer',
        'Reintegration of pre-1940 private enterprise',
      ],
      0,
      'Dej\'s early Stalinist phase destroyed the peasant economy through collectivization and brutal grain extraction, financing Soviet-model industrialization.',
    ],
    [
      'Ceaușescu\'s "independence within the bloc" required which precondition internally?',
      [
        'Party unity and nationalist ideology',
        'Military alliance with non-aligned nations',
        'Economic integration with Western Europe',
        'Multiparty democratic competition',
      ],
      0,
      'Ceaușescu fostered nationalism and cult of personality to maintain regime cohesion without Soviet backing, enabling his foreign-policy maneuvering.',
    ],
    [
      'The August 1968 Prague Spring and Soviet invasion prompted Ceaușescu to mobilize civil defense forces. What was the geopolitical gamble?',
      [
        'Betting nationalist fervor deters a Soviet attack',
        'Hoping NATO would intervene militarily',
        'Requesting Yugoslav military assistance',
        'Threatening nuclear retaliation',
      ],
      0,
      'Ceaușescu\'s August 21 speech condemning the invasion risked Soviet wrath but deepened his nationalist legitimacy domestically and internationally.',
    ],
    [
      'Ceaușescu\'s "Systematization" program was justified ideologically as achieving which socialist objective?',
      [
        'Eliminating peasant "backwardness" through forced urbanization',
        'Restoring traditional village life',
        'Privatizing agricultural land to individual farmers',
        'Strengthening NATO defense infrastructure',
      ],
      0,
      'Systematization rhetoric employed Stalinist tropes of eradicating "rural obscurantism"; in reality it was resource extraction and demographic control.',
    ],
    [
      'Post-1970 Romania\'s foreign debt crisis and austerity measures (the "Golden Age") were consequences of which prior policy decisions?',
      [
        'Heavy borrowing for prestige industrial projects',
        'Trade embargoes imposed by NATO countries',
        'Soviet dumping of cheap goods on Romanian markets',
        'Intentional IMF austerity conditions',
      ],
      0,
      'Ceaușescu\'s monumental industrialization projects (steel mills, the Canal) consumed foreign credits but produced inefficient, loss-making enterprises.',
    ],
    [
      'The December 1989 revolution\'s "Timișoara" phase (Dec 15–21) and its escalation to the "Bucharest" phase (Dec 22–25) involved which key transition?',
      [
        'Local protest turning into a nationwide uprising',
        'A shift from peaceful protest to violent armed insurrection',
        'The arrival of NATO peacekeeping forces',
        'Soviet military intervention',
      ],
      0,
      'Timișoara\'s Dec 15–21 unrest spread nationally; when army units defected on Dec 21–22, Ceaușescu\'s power evaporated, culminating in his Dec 25 trial and execution.',
    ],
  ],
};
